import { GlobalState } from 'ha/types/store';
import { createSelector } from 'reselect';
import { getIsAdvertiser } from '../AuthLogic/selectors';

export const getIsRMSDashboardEnabled = (s: GlobalState) => {
  return s.FEATURE_FLAGS.useRMSDashboard === 'on';
};

export const getShowNewTaxonomy = createSelector(
  [getIsRMSDashboardEnabled, getIsAdvertiser],
  (isRMSDashboardEnabled, isAdvertiser) => {
    return isRMSDashboardEnabled && isAdvertiser;
  },
);
